import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { "element-loading-background": "rgba(0, 0, 0, 0.5)" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px"} }, " 货物清单 ", -1)
const _hoisted_3 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-6px","margin-right":"-10px"} }
const _hoisted_4 = { style: {"height":"600px"} }
const _hoisted_5 = ["title"]
const _hoisted_6 = ["title"]
const _hoisted_7 = ["title"]
const _hoisted_8 = ["title"]
const _hoisted_9 = ["title"]
const _hoisted_10 = ["title"]
const _hoisted_11 = ["title"]
const _hoisted_12 = { style: {"clear":"both","float":"right","margin-top":"15px","height":"25px"} }
const _hoisted_13 = { style: {"clear":"both","height":"25px","padding-top":"3px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CloseBold = _resolveComponent("CloseBold")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_miezz_input = _resolveComponent("miezz-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_miezz_button_bar = _resolveComponent("miezz-button-bar")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.ruleForm.Visible,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.ruleForm.Visible) = $event)),
      top: "0px",
      "show-close": false,
      style: {"width":"96%"},
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "append-to-body": true
    }, {
      header: _withCtx(({ close }) => [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_icon, {
            style: {"cursor":"pointer"},
            onClick: close
          }, {
            default: _withCtx(() => [
              _createVNode(_component_CloseBold)
            ]),
            _: 2
          }, 1032, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref: "customsPackageRuleForm",
          model: _ctx.list.Data
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_el_table, {
                ref: "customsPackageTable",
                data: _ctx.list.Data.Items,
                onSelectionChange: _ctx.handleSelectionChange
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    type: "selection",
                    width: "55"
                  }),
                  _createVNode(_component_el_table_column, {
                    type: "index",
                    label: "序号",
                    width: "80"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "Code",
                    label: "包装编号",
                    width: "150"
                  }, {
                    default: _withCtx((scope) => [
                      (scope.row.PackageZh)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            style: {"width":"100% !important","word-break":"break-all","overflow":"hidden","height":"26px","line-height":"26px"},
                            title: scope.row.Code
                          }, _toDisplayString(scope.row.Code), 9, _hoisted_5))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "SpecQuantity",
                    label: "箱规cm*cm*cm与数量"
                  }, {
                    default: _withCtx((scope) => [
                      _createElementVNode("div", {
                        style: {"width":"100% !important","overflow":"hidden","word-break":"break-all","height":"26px","line-height":"26px"},
                        title: scope.row.SpecQuantity
                      }, _toDisplayString(scope.row.SpecQuantity), 9, _hoisted_6)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "GrossWeight",
                    label: "毛重KGS",
                    width: "120px"
                  }, {
                    default: _withCtx((scope) => [
                      _createElementVNode("div", {
                        style: {"width":"100% !important","overflow":"hidden","word-break":"break-all","height":"26px","line-height":"26px"},
                        title: scope.row.GrossWeight
                      }, _toDisplayString(scope.row.GrossWeight), 9, _hoisted_7)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "Volume",
                    label: "体积CBM",
                    width: "120px"
                  }, {
                    default: _withCtx((scope) => [
                      _createElementVNode("div", {
                        style: {"width":"100% !important","overflow":"hidden","height":"26px","line-height":"26px"},
                        title: scope.row.Volume
                      }, _toDisplayString(scope.row.Volume), 9, _hoisted_8)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "ProductName",
                    label: "产品名称"
                  }, {
                    default: _withCtx((scope) => [
                      _createElementVNode("div", {
                        style: {"width":"100% !important","overflow":"hidden","height":"26px","line-height":"26px"},
                        title: scope.row.ProductName
                      }, _toDisplayString(scope.row.ProductName), 9, _hoisted_9)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "Quantity",
                    label: "包装数量",
                    width: "120px"
                  }, {
                    default: _withCtx((scope) => [
                      _createElementVNode("div", {
                        style: {"width":"100% !important","overflow":"hidden","height":"26px","line-height":"26px"},
                        title: scope.row.Quantity
                      }, _toDisplayString(scope.row.Quantity), 9, _hoisted_10)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "AddQuantity",
                    label: "添加数量",
                    width: "180px"
                  }, {
                    default: _withCtx((scope) => [
                      _createElementVNode("div", {
                        style: {"width":"100% !important","overflow":"hidden","height":"46px"},
                        title: scope.row.AddQuantity
                      }, [
                        (scope.row.IsSelected == true)
                          ? (_openBlock(), _createBlock(_component_el_form_item, {
                              key: 0,
                              "label-width": "25px",
                              label: " ",
                              prop: 'Items.' + scope.$index + '.AddQuantity',
                              rules: [
                                                          {
                                                            required: true,
                                                            message: '信息不能为空',
                                                            trigger: 'blur',
                                                          },
                                                        ]
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_miezz_input, {
                                  placeholder: "请填写",
                                  disabled: false,
                                  modelValue: scope.row.AddQuantity,
                                  "onUpdate:modelValue": ($event: any) => ((scope.row.AddQuantity) = $event),
                                  onBlur: ($event: any) => (_ctx.onChangeQuantity(scope.$index))
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur"])
                              ]),
                              _: 2
                            }, 1032, ["prop"]))
                          : (_openBlock(), _createBlock(_component_el_form_item, {
                              key: 1,
                              "label-width": "0px",
                              label: ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_miezz_input, {
                                  placeholder: "请填写",
                                  disabled: true,
                                  modelValue: scope.row.AddQuantity,
                                  "onUpdate:modelValue": ($event: any) => ((scope.row.AddQuantity) = $event)
                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                              ]),
                              _: 2
                            }, 1024))
                      ], 8, _hoisted_11)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["data", "onSelectionChange"]),
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_el_pagination, {
                  "current-page": _ctx.ruleForm.CurrentPage,
                  onCurrentChange: _ctx.handleCurrentChange,
                  small: true,
                  background: "",
                  layout: "total, prev, pager, next, jumper",
                  total: _ctx.ruleForm.Total
                }, null, 8, ["current-page", "onCurrentChange", "total"])
              ])
            ])
          ]),
          _: 1
        }, 8, ["model"]),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_miezz_button_bar, {
            modelValue: _ctx.bottomButtons,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.bottomButtons) = $event)),
            isBackground: true,
            onHandleClick: _ctx.handleClick
          }, null, 8, ["modelValue", "onHandleClick"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ])), [
    [
      _directive_loading,
      _ctx.isLoading,
      void 0,
      {
        fullscreen: true,
        lock: true
      }
    ]
  ])
}